import { Beacon } from '../Beacon';
import { AdserverRequestId, BeaconType } from '../types';
import { getBaseParams } from '../utils/getBaseParams';

export const dispatchVastError = (arid: AdserverRequestId, error: number) => {
  return new Beacon({
    data: {
      type: BeaconType.vastErrorCode,
      error,
      arid,
      ...getBaseParams(arid)
    }
  });
};
